var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#checkbox_svg__clip0_5976_3674)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(.757 -68.629 14.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(.757 -68.629 14.457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.628 1.073L1.74.929A1.555 1.555 0 00.165 2.464L.02 13.352a1.555 1.555 0 001.534 1.575l10.888.144a1.555 1.555 0 001.576-1.534l.144-10.888a1.555 1.555 0 00-1.535-1.576zM5.485 11.868l-3.837-3.94 1.111-1.082 2.755 2.821 5.981-5.825 1.082 1.12-7.092 6.906z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "checkbox_svg__clip0_5976_3674"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(.757 -68.629 14.457)",
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgCheckbox;